import type { SnackBarPropGetItemMessage } from '@consta/uikit/SnackBar'
import { Text } from '@consta/uikit/Text'
import type { ActionsOnClickKey, GeomateNotification, NotificationId } from 'common/types'

export const getItemMessage: SnackBarPropGetItemMessage<GeomateNotification> = item => {
  if (typeof item.message === 'string') return item.message

  switch (item.message.type) {
    case 'polygon':
      return (
        <Text size="m" lineHeight="s" view="primary">
          {item.message.label}
          <p>{item.message.caption}</p>
        </Text>
      )
  }
}

export const useActions = (undoDelete?: (notificationId: NotificationId) => void) => {
  const getHandler = (key: ActionsOnClickKey, notificationId: NotificationId): VoidFunction => {
    switch (key) {
      case 'undoDelete':
        return () => undoDelete?.(notificationId)
    }
  }
  return getHandler
}
